import { gql } from '@apollo/client';

const GET_PAGES = gql`
  query ($booksWhere: BooksWhereInput!, $pagesWhere: PagesWhereInput) {
    books(where: $booksWhere) {
      id
      type
      title
      bookCode
      orientation
      edition
      totalPages
      path
      locale
      offset
      url
      characters {
        id
        character
        characterType
        characterCase
      }
      pages(where: $pagesWhere) {
        id
        pageNumber
        src
        characters {
          id
          character
          characterType
          characterCase
        }
      }
    }
  }
`;

export default GET_PAGES;
